import React, { useState } from 'react';
import ContantLoader from 'views/ContantLoader';
import SelectTemplateCard from './SelectTemplateCard';
import { useSelector } from 'react-redux';
import SelectTemplateBottom from 'views/Templates/SelectTemplateComponent/SelectTemplateBottom';
import './styles.css'
export default function SelectTemplateTab({
  id,
  tab,
  templateData,
  loading,
  urlToCreateTemplate,
  setTemplateOnTheURL,
  offSet,
  PreviousDataShowing,
  matchNextButton,
  NextDataShowing,
  templatePageCount,
  templateCount,
}) {
  const userSetter = useSelector((state) => state.userSetter);
  const campaignSetter = useSelector((state) => state.campaignSetter);
  const templateSetter = useSelector((state) => state.templateSetter);
  const { role } = useSelector(
    (state) => state.userSetter
  );
  const showTemplateEditCard = () => {
    if (userSetter.userFlow == 'createCampaign') {
      if (campaignSetter.currentABTestCampaign == 'A') {
        return campaignSetter.campignTemplateId !== null ? true : false;
      } else if (campaignSetter.currentABTestCampaign == 'B') {
        return campaignSetter.campaingABTestData.campaignABTestTemplateId !== null ? true : false;
      }
    } else if (userSetter.userFlow == 'createTemplate') {
      return templateSetter.templateId !== null ? true : false;
    }
    return;
  };

  return (
    <div className='template_block'>
      {!loading ? (
        <div>
          {/* <div className='card_inn_heading mb-4'>
            <h3>Featured</h3>
          </div> */}
          <p className='sm d-flex align-items-center'>
            You have {templateCount} templates.
            <span className='inline-label ml-auto'>
              Page No. {matchNextButton} of {templatePageCount}
            </span>
          </p>
          <div className='row templates-row'>
            {showTemplateEditCard() && (tab === 'layoutTemplateTab' || (tab == 'leadConnect' && role =='publisher')) && (
              <SelectTemplateCard
                urlToCreateTemplate={urlToCreateTemplate}
                imgSource={require('assets/img/templateEditing.svg')}
                title='Continue Editing'
                description='Description'
                type='edit'
                isExclusive={false}
                setTemplateOnTheURL={setTemplateOnTheURL}
                template_type={null}
                template_id={null}
              />
            )}

            {templateData &&
              templateData.map((template) => {
                return (
                  <SelectTemplateCard
                    urlToCreateTemplate={urlToCreateTemplate}
                    imgSource={template.imageUrl}
                    title={template.name}
                    description={template.description}
                    type='create'
                    isExclusive={template.isExclusive}
                    setTemplateOnTheURL={setTemplateOnTheURL}
                    template_type={template.type}
                    template_id={template.id}
                    htmlData={template.type == 'email' ? template.html : template["grapesjs-react-editorhtml"]}
                  />
                );
              })}
          </div>
          <SelectTemplateBottom
            offSet={offSet}
            PreviousDataShowing={PreviousDataShowing}
            nextButton={templatePageCount}
            matchNextButton={matchNextButton}
            NextDataShowing={NextDataShowing}
            layout_type={id}
          />
        </div>
      ) : (
        <ContantLoader />
      )}
    </div>
  );
}
